import Button from '@ui/Button';
import { InputFormField } from '@ui/Form/Fields';
import { Translate, I18n } from 'react-redux-i18n';
import React, { FC } from 'react';
import { useForm } from 'react-hook-form';
import Form from '@ui/Form';
import styles from './styles.module.scss';
import { getValidators } from '../validation';
import { yupResolver } from '@hookform/resolvers/yup';
import { userApi } from '@api/index';

interface Props {
  onComplete: () => void;
}

const RegisterChild: FC<Props> = ({ onComplete }) => {
  const { childValidation } = getValidators();
  const formMethods = useForm<FormData>({
    mode: 'all',
    resolver: yupResolver(childValidation),
    reValidateMode: 'onChange',
    defaultValues: {},
  });

  const handleFormSubmit = async (values: FormData) => {
    try {
      await userApi.createChild(values);
      onComplete && onComplete();
    } catch (error) {
      alert(error.response.body.error);
    }
  };

  return (
    <div className={styles.wrapper}>
      <div className={styles.left}>
        <span className={styles.stepTitle}>
          {I18n.t('onboarding.regChild.title')}
        </span>
        <p className={styles.stepHint}>{I18n.t('onboarding.regChild.info')}</p>
      </div>
      <div className={styles.right}>
        <Form formMethods={formMethods} onSubmit={handleFormSubmit}>
          <InputFormField name="name" placeholder={I18n.t('register.nick')} />
          <InputFormField
            type="password"
            name="password"
            placeholder={I18n.t('placeholder.password')}
            autoComplete="off"
          />

          <div className={styles.actionsWrapper}>
            <Button color="green" type="submit">
              <Translate value="auth.signup" />
            </Button>
            <Button color="white" onClick={onComplete}>
              {I18n.t('onboarding.hasAccount')}
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default RegisterChild;
